import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='new-york-customers'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'>
          New York Customers
        </Typography>
        <Typography>
          New York Insurance Law &#167; 2612, with respect to all insurers regulated under the Insurance Law, including
          health maintenance organizations (&#34;HMOs&#34;), provides in relevant part that if any person covered by an
          insurance policy delivers to the insurer a valid order of protection against the policyowner or other
          person covered by the policy, then the insurer is prohibited for the duration of the order from disclosing
          to the policyholder or other person the address and telephone number of the insured, or of any person
          or entity providing the covered services to the insured. If a child is a covered person, then the right
          established by this section may be asserted by the child&#39;s parent of guardian.
        </Typography>
        <Typography>
          Effective January 1, 2003, Insurance Law &#167; 2612 also requires a health insurer, as defined in that section
          to include long term care and disability income insurance, to accommodate a reasonable request made by
          a person covered by an insurance policy or contract to receive communications of claim&#45;related information
          by alternative means or at alternative locations if the person clearly states that disclosure of the
          information could endanger the person. If a child is the covered person, then this right may be asserted
          by the child&#39;s parent or guardian.
        </Typography>
        <Typography>
          Except with the express consent of the person making the request, a health insurer may not disclose to the
          policyholder: (1) the address, telephone number, or any other personally identifying information of the
          person who has made the request or child for whose benefit a request was made; (2) the nature of the
          health care services provided&#59; or (3) the name or address of the provider of covered services.
        </Typography>
        <Typography>
          The New York State Department of Financial Services (&#34;Department&#34;) has promulgated 11 NYCRR 244 (Insurance
          Regulation 168), which requires insurers to develop and implement confidentiality protocols. For health
          insurers, this also must include written procedures by which a person may make a reasonable request to
          receive communications of claim&#45;related information by alternative means or at alternative locations
          and procedures for revoking such a request.
        </Typography>
        <Typography>
          For further information on domestic violence services, you can contact the NYS Domestic and Sexual Violence
          Hotline by dialing 1&#45;800&#45;942&#45;6906 or by accessing the&#160;
          <Link
            id="new-york-customers-website-link"
            variant='primaryDeemphasize'
            linkUrl="https://opdv.ny.gov/survivors-victims/"
            isOutgoingLink>
            New York State Office for the Prevention of Domestic Violence website
          </Link>.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
